<template>
    <div class="page">
        <public-head title="校派"></public-head>
        <div class="header">
            <van-swipe :autoplay="3000" indicator-color="white">
                <van-swipe-item>
                    <img :src="schoolInfo.thumb" class="slide-image" style="width:100%" />
                </van-swipe-item>
            </van-swipe>
        </div>
        <!-- 导航 -->
        <div class="nav">
            <div class="nav-item">
                <div
                    v-for="(item,index) in menuList"
                    :key="index"
                    :class="[currentTab==index?'nav-active':'']"
                    @click="selectMenu(index)"
                >{{item}}</div>
            </div>
        </div>

        <!--********************学校概况********************-->
        <div v-if="currentTab ===0 ">
            <!-- 学校介绍 -->
            <div class="school-info">
                <div class="school-title">{{schoolInfo.school_name}}</div>
                <div class="school-tags">
                    <div class="tags">学校类型:{{schoolInfo.institution_type[0]}}</div>
                    <div class="tags">所在地:{{schoolInfo.province}}{{schoolInfo.city}}</div>
                    <div class="tags">批次:{{schoolInfo.disciplinary_level}}</div>
                </div>
                <!-- 转发等功能 -->
                <div class="function">
                    <div class="function-item">
                        <div style="background:#fff" class="iconfont icon-zhuanfa button-hover"></div>
                        <div>{{schoolInfo.share}}分享</div>
                    </div>
                    <div class="function-item">
                        <div class="font_family sharebtn icon-shoucang"></div>
                        <div>{{schoolInfo.hits}}浏览</div>
                    </div>
                </div>
            </div>
            <!--  -->
            <div class="info">
                <div class="line"></div>
                <div class="title">学院介绍</div>
                <div class="solid"></div>
                <div class="info-detail">
                    <p v-html="schoolInfo.description"></p>
                </div>
            </div>
        </div>
        <!--********************招生简章********************-->
        <div v-if="currentTab ===1 " class="major">
            <div class="enrollment-name">{{enrollmentInfo.enrollment_name}}</div>
            <div class="enrollment-content">
                <p v-html="enrollmentInfo.enrollment_content" class="fuwen"></p>
            </div>
        </div>

        <!--********************开设专业********************-->
        <div v-if="currentTab ===2 ">
            <div v-for="(item,index) in majorList" :key="index">
                <div class="apply" @click="showMore(index)">
                    <div class="circle"></div>
                    <div class="apply-title">{{item.name}}</div>
                    <div class="icon">
                        <div v-if="!item.isOpen" class="font_family icon-youhua jiantou"></div>
                        <div v-if="item.isOpen" class="font_family icon-xiahua jiantou"></div>
                    </div>
                </div>
                <!-- 专业详情  -->
                <div v-if="item.isOpen">
                    <div class="apply-detail">
                        <div>
                            <div style="display:flex;">
                                <div class="ico"></div>
                                <div class="detail-title">专业特色</div>
                            </div>
                            <div class="info-detail">{{item.professional_introduction}}</div>
                        </div>
                        <div style="display:flex;margin-top:20rpx;">
                            <div class="ico"></div>
                            <div class="detail-title">就业方向</div>
                        </div>
                        <div class="info-detail">{{item.sem}}</div>

                        <div style="display:flex;margin-top:20rpx;">
                            <div class="ico"></div>
                            <div class="detail-title">课程设置</div>
                        </div>
                        <div class="info-detail">{{item.courses}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { httpPost } from "../../../axios/index";
import PublicHead from "../../../components/publicHead";
import BScroll from "better-scroll";
import share from '../../../util/share.js'

export default {
    data() {
        return {
            indicatorDots: true,
            autoplay: true,
            interval: 5000,
            duration: 1000,
            currentTab: 0,
            schoolInfo: {},
            enrollmentInfo: {},
            school_id: "",
            bannerList: [],
            menuList: ["学校概况", "招生简章", "开设专业"],
            schoolList: [],
            majorList: [],
            isretrue: 0
        };
    },
    created() {},
    methods: {
        // 点击开设专业显示内容‘
        showMore(i) {
            var index=i;
            var majorList =this.majorList;
            majorList[index].isOpen = !majorList[index].isOpen;
        },
        // 点击导航切换
        selectMenu(e) {
            if (e === 1) {
                httpPost("/vocational/school_enrollment", {
                    sid: this.$route.query.sid
                }).then(res => {
                    if (res.code === 1) {
                        this.enrollmentInfo = res.info;
                    }
                });
            }
            if (e === 2) {
                httpPost("/vocational/school_career", {
                    sid: this.$route.query.sid
                }).then(res => {
                    if (res.code === 1) {
                         var majorList = res.list;
                         for (var i = 0; i < majorList.length; i++) {
                            majorList[i].isOpen = false;
                        }
                        this.majorList = majorList;
                    }
                });
            }
            this.currentTab = e;
        },
        fetchSchoolDetail() {
            // 获取学校详情数据
            httpPost("/vocational/school_details", {
                sid: this.$route.query.sid
            }).then(res => {
                if (res.code === 1) {
                    this.schoolInfo = res.info;
                    
                        share(res.info);
                }
            });
        }
    },
    mounted() {
        this.fetchSchoolDetail();
    },
    components: {
        PublicHead
    }
};
</script>

<style scoped>
.page {
    background: #f2f2f2;
}
.enrollment-content {
    width: 100%;
}
.fuwen >>> img,p,span{
    width: 100%;
}
.enrollment-content>p>span>img {
    width: 300px !important;
}
van-swipe {
    height: 12.5rem;
    width: 100%;
}

van-swipe img {
    width: 100%;
    height: 12.5rem;
}

/*导航菜单模块*/
.header {
    margin-top: 46px;
}
.nav {
    position: relative;
    font-family: PingFang-SC-Regular;
    font-size: 0.875rem;
    color: #f2f2f2;
    background: #22d9d9;
    height: 10vw;
    padding-top: 0.375rem;
}

.nav-item {
    display: flex;
    justify-content: space-around;
    position: absolute;
    text-align: center;
    width: 90vw;
    margin: 0 5vw;
    top: 0.8125rem;
    font-size: 1rem;
    line-height: 1;
}

.nav-active {
    color: #fff;
    font-weight: 600;
    border-bottom: 0.0625rem #fff solid;
    padding-bottom: 0.3125rem;
}

/*学校概况*/

.school-info {
    background: #fff;
}

.school-title {
    font-size: 1.0625rem;
    color: #383838;
    font-weight: 600;
    padding: 0.9375rem;
}

.school-tags {
    display: flex;
    margin-top: 0.3125rem;
    font-size: 0.875rem;
    border-bottom: 0.0625rem #22d9d9 solid;
    padding-bottom: 0.625rem;
    padding-left: 1rem;
}

.tags {
    background: #22d9d9;
    color: #fff;
    padding: 0 0.3rem;
    border-radius: 0.75rem;
    margin-left: 0.625rem;
}

.tags:nth-child(1) {
    margin-left: 0;
}

.function {
    display: flex;
    padding: 0.625rem 0;
}

.function-item {
    margin-left: 1rem;
    font-size: 0.875rem;
    color: #bcbcbc;
}

.function-item text:nth-child(2) {
    padding-left: 0.3125rem;
}

.info {
    background: #fff;
    margin-top: 1rem;
    position: relative;
}

.info-detail {
    padding: 0.625rem;
    color: #888;
    font-size: 0.875rem;
}

.line {
    position: absolute;
    width: 7rpx;
    height: 1.25rem;
    background: #22d9d9;
    top: 1.75rem;
    left: 0.9375rem;
}

.title {
    font-weight: 600;
    color: #383838;
    font-size: 1.125rem;
    margin-left: 1.625rem;
    padding: 1.5625rem 0;
}

.solid {
    border-bottom: 0.0625rem #22d9d9 solid;
}

/* 招生简章 */

.apply {
    line-height: 2.5rem;
    display: flex;
    background: #fff;
    border-bottom: 0.0625rem #f2f2f2 solid;
    position: relative;
}

.circle {
    width: 0.625rem;
    height: 0.625rem;
    border-radius: 0.625rem;
    margin-left: 0.625rem;
    margin-top: 0.9375rem;
    background: #22d9d9;
}

.apply-title {
    margin-left: 0.625rem;
    font-size: 1rem;
    /* font-weight: 32rpx; */
    color: #383838;
}

.apply-detail {
    font-size: 0.875rem;
    color: #989898;
    line-height: 1.4375rem;
    padding: 0.8125rem;
}

.icon {
    font-size: 1.875rem;
    position: absolute;
    top: 0;
    right: 0.625rem;
}

.ico {
    width: 0.25rem;
    height: 0.9375rem;
    background: #22d9d9;
    margin-top: 0.1875rem;
}

.detail-title {
    font-size: 1rem;
    font-weight: 600;
    color: #383838;
    padding-left: 0.625rem;
}

.enrollment-name {
    font-size: 1rem;
    color: #383838;
    font-weight: 600;
    padding: 0.625rem;
}

.enrollment-content {
    font-size: 0.875rem;
    color: #888;
    padding: 0.625rem;
}

.major {
    background: #fff;
}
</style>